export const ADD_TRANSACTION = 'ADD_TRANSACTION';
export const UPDATE_TRANSACTIONS = 'UPDATE_TRANSACTIONS';
export const FINISH_TRANSACTION = 'FINISH_TRANSACTION';
export const SYNC_TRANSACTIONS_STATE = 'SYNC_TRANSACTIONS_STATE';

export interface AddTransactionAction {
  type: typeof ADD_TRANSACTION;
  hash: string;
  onComplete?: (isSucceed?: boolean) => void;
  payload: {
    hash: string;
    summary: string;
    from: string;
    addedTime: number;
    completeMessage?: string;
    errorMessage?: string;
  };
}

export interface UpdateTransactionsAction {
  type: typeof UPDATE_TRANSACTIONS;
}

export interface FinishTransactionAction {
  type: typeof FINISH_TRANSACTION;
  hash: string;
  payload: {
    confirmedTime: number;
    status: 0 | 1;
  };
}

export interface SyncTransactionsStateAction {
  type: typeof SYNC_TRANSACTIONS_STATE;
  payload: any;
}

export type TransactionActionTypes =
  | AddTransactionAction
  | UpdateTransactionsAction
  | FinishTransactionAction
  | SyncTransactionsStateAction;
